/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_RequiredInputs */

const en_auth_password_required = /** @type {(inputs: Auth_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password is required`)
};

const es_auth_password_required = /** @type {(inputs: Auth_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraseña es obligatoria`)
};

/**
* | output |
* | --- |
* | "Password is required" |
*
* @param {Auth_Password_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_password_required = /** @type {((inputs?: Auth_Password_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_password_required(inputs)
	return en_auth_password_required(inputs)
});